import { render, staticRenderFns } from "./icompanies.vue?vue&type=template&id=590e5b9c&scoped=true&"
import script from "./icompanies.vue?vue&type=script&lang=js&"
export * from "./icompanies.vue?vue&type=script&lang=js&"
import style0 from "./icompanies.vue?vue&type=style&index=0&id=590e5b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e5b9c",
  null
  
)

export default component.exports